import { Card, CardContent, CardFooter, CardHeader } from '@playbooks/ui/components/card';
import { Skeleton } from '@playbooks/ui/components/skeleton';
import { cn } from '@playbooks/ui/lib/utils';

import type { SkeletonBaseProps } from './types';

const GridSkeleton = ({ className = '' }: SkeletonBaseProps) => {
	// Theme
	const rootClassName = cn('flex-column h-full gap-0 py-0', 'overflow-hidden', className);

	// Render
	return (
		<Card className={rootClassName}>
			<CardHeader className='aspect-[16/9] bg-surface-hover p-0'>
				<Skeleton className='leading-[inherit]' />
			</CardHeader>
			<CardContent className='grow space-y-2 border-t p-3'>
				<Skeleton className='w-1/3' />
				<Skeleton className='w-2/3' />
			</CardContent>
			<CardFooter className='flex-start gap-2 border-t-0 bg-transparent px-3 pt-0 pb-3'>
				<span className='aspect-[1/1] w-5'>
					<Skeleton className='rounded-full' />
				</span>
				<span className='w-1/3'>
					<Skeleton />
				</span>
				<span className='ml-auto w-1/5'>
					<Skeleton />
				</span>
			</CardFooter>
		</Card>
	);
};
export { GridSkeleton };
